import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SSRProvider } from '@react-aria/ssr';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from '../GlobalStyle';
const DesignSystemProvider = ({ theme, children, }) => {
    return (_jsxs(SSRProvider, { children: [_jsx(GlobalStyle, {}), _jsx(ThemeProvider, { theme: theme, children: children })] }));
};
export default DesignSystemProvider;
//# sourceMappingURL=index.js.map